module.exports = __webpack_public_path__ + "static/media/chancellor_richey.6ffbd210.png";